import { toast } from 'react-toastify';

export const showPaymentSuccess = (planName: string, billingCycle: string) => {
  try {
    toast.success(
      `🎉 Payment successful! Your ${planName} plan (${billingCycle}) has been activated.`,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `payment-success-${Date.now()}`, // Prevent duplicate toasts
      }
    );
  } catch (error) {
    console.error('Error showing payment success toast:', error);
  }
};

export const showPaymentError = (message: string = 'Payment failed. Please try again.') => {
  try {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: `payment-error-${Date.now()}`, // Prevent duplicate toasts
    });
  } catch (error) {
    console.error('Error showing payment error toast:', error);
  }
};

export const showPaymentDismissed = () => {
  try {
    toast.info('Payment cancelled by user.', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: `payment-dismissed-${Date.now()}`, // Prevent duplicate toasts
    });
  } catch (error) {
    console.error('Error showing payment dismissed toast:', error);
  }
};